export const endpoints = {
    music: "https://cors-anywhere-kev.herokuapp.com/http://api.deezer.com",
    musicWithoutProxy: "https://api.deezer.com",
}